import constantes from '../helpers/constanteHelper'
import { retornarTexto } from '../helpers/textoHelper'

import Image from 'react-bootstrap/Image';

import aves from '../images/aves.png'
import bovinos from '../images/bovinos.png'
import pescados from '../images/pescados.png'
import pets from '../images/pets.png'
import suinos from '../images/suinos.png'
import camaroes from '../images/camaroes.png'
import caes from '../images/caes.png'
import gatos from '../images/gatos.png'
import equinos from '../images/equinos.png'

function Especies({ item, resolucaoMobile, idioma }) {
    const estiloIcone = { height: '35px' }

    const especies = [item['Aves'], item['Bovinos'], item['Aqua - Peixes'], item['Aqua - Camarões'], item['Suínos'], item['Cães'], item['Gatos'], item['Equinos']]
    const temAlgumaEspecie = especies.some((especie) => especie?.toUpperCase() === 'X')

    if (!temAlgumaEspecie) return <></>

    return (
        <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center justify-content-center' style={{ gap: '20px' }}>
            <span style={{ color: constantes.CORES.BRANCO_PADRAO }} >{retornarTexto(idioma, 'especies')}: </span>
            <div className='animate__animated animate__fadeIn d-flex align-items-center justify-content-center' style={{ gap: '10px' }}>
                {item['Aves']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={aves} alt='logo' fluid /> : <></>}
                {item['Bovinos']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={bovinos} alt='logo' fluid /> : <></>}
                {item['Aqua - Peixes']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={pescados} alt='logo' fluid /> : <></>}
                {item['Aqua - Camarões']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={camaroes} alt='logo' fluid /> : <></>}
                {item['Suínos']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={suinos} alt='logo' fluid /> : <></>}
                {item['Cães']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={caes} alt='logo' fluid /> : <></>}
                {item['Gatos']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={gatos} alt='logo' fluid /> : <></>}
                {item['Equinos']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={equinos} alt='logo' fluid /> : <></>}
            </div>
        </div>
    );
}
export default Especies;
